import { SliceItem } from 'components/templates/partials/ComponentsRenderer';
import { RichText } from 'components/atoms/RichText';

export interface BlogOverviewContentHeaderProps {
  className?: string;
  children?: React.ReactNode;
  slices: SliceItem[];
}

export const BlogOverviewContentHeader: React.FC<BlogOverviewContentHeaderProps> = ({
  className,
  slices,
}) => {
  const slice = slices.find(
    (sliceItem) => sliceItem.slice_type === 'blog_uebersicht_content_header'
  );
  if (!slice) {
    return null;
  }
  return <RichText className={className} rich_text={slice.primary.content_header} />;
};
